module.exports = __webpack_public_path__ + "static/media/filter.87ee0f31.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/filter.svg
// module id = 767
// module chunks = 0